/**
 * @copyright Copyright 2021 Epic Systems Corporation
 * @file exports for auditing hooks
 * @author Colin Walters
 * @module Epic.VideoApp.Hooks.Auditing.Index
 */

export * from "./useAuditFeatureUse";
export * from "./useClientLogging";
